<template>
  <main class="v-view-primary">
    <h1 class="a-loading-primary">Página no encontrada</h1>
    <!--<OrganismTheHeader/>
    <OrganismNotFound/>-->
  </main>
</template>

<script>
export default {
  name: 'NotFound',

  components: {
    // OrganismNotFound: () => import('@/components/organisms/OrganismNotFound')
  }
}
</script>
